import { render, staticRenderFns } from "./Ranking.vue?vue&type=template&id=2104c22a&"
import script from "./Ranking.vue?vue&type=script&lang=js&"
export * from "./Ranking.vue?vue&type=script&lang=js&"
import style0 from "./Ranking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "packages/cb-components-ranking/src/components/rank/Ranking.vue"
export default component.exports